import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from "dayjs";

import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminCCTV(props) {
    const formcomRef = useRef(null)

    const [camera, setCamera] = useState({
        ip_address: "192.168.10.15",
        rtsp_port: "554",
        username: "admin",
        password: "%40Admin12345",
        total_cam: 1,
        brand: "HikVision"
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        api_get_camera()
        return () => {
            setCamera({});
        }
    }, []);

    async function api_get_camera() {
        setmodal_load({ enable: true, message: "Loading common system." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/cctv/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.camera !== undefined) {
                        setCamera(response.data.camera)
                    }
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_save_camera() {
        setmodal_load({ enable: true, message: "Creating Camera Configuration" })
        await sleep(500)

        const formData = new FormData()
        formData.append('ip_address', camera.ip_address)
        formData.append('rtsp_port', camera.rtsp_port)
        formData.append('username', camera.username)
        formData.append('password', camera.password)
        formData.append('total_cam', camera.total_cam)
        formData.append('brand', camera.brand)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/cctv/edit", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your camera config has been created, please reboot to reload new config.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-cctv"></i> CCTV</h4>
                                    <p className="mb-3">Manage your cctv system</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_get_camera() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formcomRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="ip_address">NVR IP Address</label>
                                    <input type="text" className="form-control" name="ip_address" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" value={camera.ip_address} onChange={(e) => {
                                        setCamera({
                                            ...camera,
                                            ip_address: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="rtsp_port">RTSP Port</label>
                                    <input type="text" className="form-control" name="rtsp_port" min={1} max={65535} value={camera.rtsp_port} onChange={(e) => {
                                        setCamera({
                                            ...camera,
                                            rtsp_port: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="username">Username</label>
                                    <input type="text" className="form-control" name="username" value={camera.username} onChange={(e) => {
                                        setCamera({
                                            ...camera,
                                            username: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="password">Password</label>
                                    <input type="text" className="form-control" name="password" value={camera.password} onChange={(e) => {
                                        setCamera({
                                            ...camera,
                                            password: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="total_cam">Total Camera</label>
                                    <input type="number" className="form-control" name="total_cam" min={1} max={12} value={camera.total_cam} onChange={(e) => {
                                        setCamera({
                                            ...camera,
                                            total_cam: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="brand">Brand</label>
                                <select name="brand" className="form-select mb-3" value={camera.brand} onChange={(e) => {
                                    setCamera({
                                        ...camera,
                                        brand: e.target.value
                                    })
                                }} required>
                                    <option value="HikVision">Hik Vision</option>
                                    <option value="DAHUA">DAHUA</option>
                                </select>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-3 mb-1 mt-3">
                            <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_save_camera() }}><i className="fe-save"></i> Save</button>
                        </div>
                    </div>
                    <hr className="new-section-xs" />
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminCCTV